module.exports = __webpack_public_path__ + "img/digikey.edb04b2d.png";